<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>任务配置</span>
          <CommonExport :import-p="'config:taskConfig:import'" :export-p="'config:taskConfig:export'" :get-table="getTables" :import-method="importTaskCfg" :export-method="exportTaskCfg" />
        </div>

        <el-form :inline="true" class="demo-form-inline">
          <el-row v-for="(item, index) in formData" :key="index">
            <el-form-item label="任务ID">
              <el-input v-model.number="item.id" style="width: 100px;" placeholder="任务ID" />
            </el-form-item>
            <el-form-item label="名称">
              <el-input v-model.number="item.task_title" style="width: 150px;" placeholder="名称" />
            </el-form-item>
            <el-form-item label="多语言">
              <el-input v-model.number="item.lang_key" style="width: 250px;" placeholder="多语言" />
            </el-form-item>
            <!--            <el-form-item label="语言配置">-->
            <!--              <el-button type="primary" size="mini" icon="el-icon-edit" @click="langVisibleArr[index].visible = true" />-->
            <!--              <el-dialog style="overflow-y: auto" title="语言配置" width="600px" :visible="langVisibleArr[index].visible">-->
            <!--                <el-form>-->
            <!--                  <el-form-item label="英文">-->
            <!--                    <el-input v-model.number="item.task_title_en" style="width: 180px;" placeholder="英文" />-->
            <!--                  </el-form-item>-->
            <!--                  <el-form-item label="繁體">-->
            <!--                    <el-input v-model.number="item.task_title_tw" style="width: 180px;" placeholder="繁體" />-->
            <!--                  </el-form-item>-->
            <!--                  <el-form-item label="法语">-->
            <!--                    <el-input v-model.number="item.task_title_fr" style="width: 150px;" placeholder="法语" />-->
            <!--                  </el-form-item>-->
            <!--                  <el-form-item label="德语">-->
            <!--                    <el-input v-model.number="item.task_title_de" style="width: 150px;" placeholder="德语" />-->
            <!--                  </el-form-item>-->
            <!--                  <el-form-item label="西班牙">-->
            <!--                    <el-input v-model.number="item.task_title_es" style="width: 150px;" placeholder="西班牙" />-->
            <!--                  </el-form-item>-->
            <!--                  <el-form-item label="葡萄牙">-->
            <!--                    <el-input v-model.number="item.task_title_pt" style="width: 150px;" placeholder="葡萄牙" />-->
            <!--                  </el-form-item>-->
            <!--                  <el-form-item label="泰语">-->
            <!--                    <el-input v-model.number="item.task_title_th" style="width: 150px;" placeholder="泰语" />-->
            <!--                  </el-form-item>-->
            <!--                </el-form>-->
            <!--                <div slot="footer" class="dialog-footer">-->
            <!--                  <el-button @click="langVisibleArr[index].visible = false">取 消</el-button>-->
            <!--                  <el-button type="primary" @click="langVisibleArr[index].visible = false">确 定</el-button>-->
            <!--                </div>-->
            <!--              </el-dialog>-->
            <!--            </el-form-item>-->
            <el-form-item label="任务类型">
              <el-input v-model.number="item.task_type" style="width: 150px;" placeholder="任务类型" />
            </el-form-item>
            <el-form-item label="类型">
              <el-select v-model="item.reward_type" placeholder="请选择">
                <el-option
                  v-for="item in selectType"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="奖励数量">
              <el-input v-model.trim="item.reward_num" style="width: 100px;" placeholder="奖励数量" />
            </el-form-item>
            <el-form-item label="任务目标值">
              <el-input v-model.number="item.target_times" style="width: 100px;" placeholder="任务目标值" />
            </el-form-item>

          </el-row>
          <el-form-item>
            <el-button v-permisaction="['config:taskCfg:add']" type="primary" @click="add()">+</el-button>
          </el-form-item>
          <el-button v-permisaction="['config:taskCfg:add']" type="primary" @click="onSubmit()">保存</el-button>
        </el-form>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getToken } from '@/utils/auth'
import { exportTaskCfg, getTaskCfgList, importTaskCfg, updateTaskCfg } from '@/api/config/task-cfg'
import CommonExport from '@/components/CommonExport/index.vue'
export default {
  name: 'TaskConfig',
  components: {
    CommonExport
  },
  data() {
    return {
      langVisibleArr: [{ visible: false }],
      total: 0,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      // 1金币,2体力,3卡片,4星星
      selectType: [
        {
          'id': 1,
          'title': '金币'
        },
        {
          'id': 2,
          'title': '体力'
        },
        {
          'id': 3,
          'title': '卡片'
        },
        {
          'id': 4,
          'title': '星星'
        }
      ],
      formData: [
        {
          'id': 0,
          'task_title': '',
          // 'task_title_en': '',
          // 'task_title_tw': '',
          // 'task_title_fr': '',
          // 'task_title_de': '',
          // 'task_title_es': '',
          // 'task_title_pt': '',
          // 'task_title_th': '',
          'lang_key': '',
          'task_type': 0,
          'reward_type': 0,
          'reward_num': 0,
          'target_times': 0
        }
      ] }
  },
  created() {
    this.getTables()
  },
  methods: {
    getTaskCfgList,
    exportTaskCfg,
    importTaskCfg,
    onSubmit() {
      for (const i in this.formData) {
        const val = this.formData[i]
        if (!val.task_title) {
          this.msgSuccess('名称不能为空')
          return
        }

        if (!val.task_type) {
          this.msgSuccess('任务类型不能为空')
          return
        }
      }
      let data = []
      this.formData.forEach((item) => {
        item.reward_num = parseFloat(item.reward_num)
        data.push(item)
      })
      data = JSON.stringify(data)
      console.log(data)
      updateTaskCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getTaskCfgList(this.queryParams).then(res => {
        // res.data.list.forEach((item, index) => {
        //   this.langVisibleArr.push({
        //     visible: false
        //   })
        // })
        this.total = res.data.count
        this.formData = res.data.list
      })
    },
    add() {
      this.formData.push({
        'id': 0,
        'task_title': 0,
        'task_title_en': '',
        'task_title_tw': '',
        'task_title_fr': '',
        'task_title_de': '',
        'task_title_es': '',
        'task_title_pt': '',
        'task_title_th': '',
        'task_type': 0,
        'reward_type': 0,
        'reward_num': 0,
        'target_times': 0
      })
      this.langVisibleArr.push({ visible: false })
    }
  }
}
</script>

<style scoped>
</style>
